import cn from 'classnames';
import React from 'react';

import { MethodsEnum } from '../../../../scripts/afterBlocks/analytics/analytics';
import { XsollaMetrikaEventNames } from '../../../../scripts/afterBlocks/analytics/analyticsEventsList';

export interface IBuyButtonProps {
  id: string;
  isForVc?: boolean;
  isPreOrder?: boolean;
  requireAuth?: boolean;
  vcSku?: string;
  type: string;
  sku: string;
  text: React.ReactNode;
  hidden?: boolean;
  xaElementValue?: string;
  xaExtra?: string;
  buttonClassPrefix?: string;
}

const BuyButton = ({
  id,
  isForVc,
  isPreOrder,
  requireAuth,
  vcSku,
  text,
  type,
  sku,
  hidden,
  xaElementValue,
  xaExtra,
  buttonClassPrefix,
}: IBuyButtonProps) => (
  <button
    id={id}
    className={cn('store__buy-btn', {
      [`${buttonClassPrefix}__buy-now`]: buttonClassPrefix,
    })}
    hidden={hidden}
    data-button-type='buy'
    data-currency-type={isForVc ? 'vc' : 'real'}
    data-is-pre-order={isPreOrder}
    data-require-auth={isForVc || requireAuth}
    data-vc={vcSku}
    data-item-type={type}
    data-sku={sku}
    data-xa-value={xaElementValue}
    data-xa-extra={xaExtra}
    data-xa-method={MethodsEnum.ELEMENT_CLICK}
    data-xa-name={XsollaMetrikaEventNames.OPEN_PS_FROM_STORE}
  >
    <span className='store__buy-btn-text'>{text}</span>
  </button>
);
export default BuyButton;
